export default {
	custom : {
		email : {
			required : 'The email is mandatory',
			email : 'You must provide a valid email address'
		},
		emailForget : {
			required : 'The email field is required',
			email : 'The email is wrong'
		},
		tipo_contacto : {
			required : 'The field that prompted the query is mandatory'
		},
		telefono : {
			required : 'The telephone field is required',
			length : 'The telephone field is wrong'
		},
		nombre : {
			required : 'The name field is required'
		},
		mensaje : {
			required : 'The message field is required'
		},
		apellidos : {
			required : 'The surname field is required'
		},
		'current-password' : {
			min : 'La contraseña debe contener como minimo 6 caracteres'
		},
		'new-password-0' : {
			min : 'La contraseña debe contener como minimo 6 caracteres'
		},
		'new-password-1' : {
			confirmed : 'Las contraseñas deben coincidir'
		},
		politica : {
			required : 'You must accept the privacy policy'
		},
		comunicaciones : {
			required : 'You must accept to send communications'
		},
		referencia_producto : {
			required : 'Product reference field is required'
		},
		tipo_catalogo : {
			required : 'The Catalog type field is required'
		},
		empresa : {
			required : 'Company field is required'
		},
		direccion : {
			required : 'The address field is required'
		},
		pais : {
			required : 'Country field is required'
		},
		area_interes : {
			required : 'Area of interest field is required'
		},
		carta_presentacion : {
			required : 'The letter of introduction field is required'
		},
	}
}


// WEBPACK FOOTER //
// ./src/validator/en.js